import axios from "axios";
import { setupInterceptors } from "./interceptors";

const axiosInstance = axios.create();

setupInterceptors(axiosInstance);

const get = async (url, options) => axiosInstance.get(url, options);
const post = async (url, data, options) =>
  axiosInstance.post(url, data, options);
const put = async (url, data, options) => axiosInstance.put(url, data, options);
const patch = async (url, data, options) =>
  axiosInstance.patch(url, data, options);
const deleteMethod = async (url, options) => axiosInstance.delete(url, options);

export { axiosInstance, get, post, put, patch, deleteMethod };
